export default "__VITE_ASSET__f49d88d5__"